import { useState } from "react";
import { Lock, User, AlertCircle, Mail } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = ({ onLogin, onClose }) => {
  const [tab, setTab] = useState("main");
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [localCreds, setLocalCreds] = useState({ email: "", password: "" });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleBasicSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${API}/admin/verify`, {
        headers: { Authorization: `Basic ${btoa(`${credentials.username}:${credentials.password}`)}` },
      });
      if (response.data.status === "authenticated") {
        onLogin(credentials);
      }
    } catch (err) {
      setError("Identifiants incorrects");
    }
    setLoading(false);
  };

  const handleLocalSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(`${API}/auth/local/login`, localCreds, { withCredentials: true });
      if (response.data.status === "ok") {
        onLogin({ type: "local", email: localCreds.email });
      }
    } catch (err) {
      setError(err.response?.data?.detail || "Identifiants incorrects");
    }
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm" data-testid="admin-login-modal" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="w-full max-w-sm p-6 rounded-2xl bg-[#131B2F] border border-white/10 shadow-2xl">
        <div className="text-center mb-6">
          <div className="inline-flex p-3 rounded-full bg-[#2395E3]/20 mb-3">
            <Lock className="w-6 h-6 text-[#00CCC2]" />
          </div>
          <h2 className="text-xl font-bold">Espace Administration</h2>
        </div>

        {error && (
          <div className="flex items-center gap-2 text-red-400 text-sm mb-4 p-3 rounded-lg bg-red-500/10" data-testid="admin-error">
            <AlertCircle className="w-4 h-4 shrink-0" /> {error}
          </div>
        )}

        {tab === "main" && (
          <form onSubmit={handleBasicSubmit} className="space-y-3">
            <div className="relative">
              <User className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input type="text" value={credentials.username} onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                placeholder="Identifiant" required autoFocus
                className="w-full pl-11 pr-4 py-3 rounded-lg bg-[#0B1121] border border-white/10 focus:border-[#2395E3] outline-none text-sm" data-testid="admin-username" />
            </div>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input type="password" value={credentials.password} onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                placeholder="Mot de passe" required
                className="w-full pl-11 pr-4 py-3 rounded-lg bg-[#0B1121] border border-white/10 focus:border-[#2395E3] outline-none text-sm" data-testid="admin-password" />
            </div>
            <button type="submit" disabled={loading}
              className="w-full px-6 py-3 btn-primary rounded-lg font-medium text-sm" data-testid="admin-login-submit">
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </form>
        )}

        {tab === "local" && (
          <form onSubmit={handleLocalSubmit} className="space-y-3">
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input type="email" value={localCreds.email} onChange={(e) => setLocalCreds({ ...localCreds, email: e.target.value })}
                placeholder="Email" required autoFocus
                className="w-full pl-11 pr-4 py-3 rounded-lg bg-[#0B1121] border border-white/10 focus:border-[#2395E3] outline-none text-sm" data-testid="local-email" />
            </div>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input type="password" value={localCreds.password} onChange={(e) => setLocalCreds({ ...localCreds, password: e.target.value })}
                placeholder="Mot de passe" required
                className="w-full pl-11 pr-4 py-3 rounded-lg bg-[#0B1121] border border-white/10 focus:border-[#2395E3] outline-none text-sm" data-testid="local-password" />
            </div>
            <button type="submit" disabled={loading}
              className="w-full px-6 py-3 btn-primary rounded-lg font-medium text-sm" data-testid="local-login-submit">
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </form>
        )}

        <div className="mt-5 pt-4 border-t border-white/10 space-y-2">
          {tab !== "main" && (
            <button onClick={() => { setTab("main"); setError(null); }}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm text-slate-400 hover:bg-white/5 transition-colors">
              <User className="w-4 h-4" /> Identifiant / Mot de passe
            </button>
          )}
          {tab !== "local" && (
            <button onClick={() => { setTab("local"); setError(null); }}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm text-slate-400 hover:bg-white/5 transition-colors"
              data-testid="local-login-toggle">
              <Mail className="w-4 h-4" /> Connexion par email
            </button>
          )}
        </div>

        <button type="button" onClick={onClose}
          className="w-full mt-4 px-6 py-2.5 rounded-lg border border-white/10 text-sm text-slate-400 hover:bg-white/5 transition-colors">
          Annuler
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
